import api from '../../api/nodeBackApi';


export const createGuestUserInURL = async (data) => {

  try {
    const response = await api.post('/api/users/createGuestUserInURL', data);
    console.log('Guest user created successfully.');
    return response.data;
  } catch (error) {
    console.error("Error creating guest user:", error);
    throw error;
  }
};
    

export const createResponsibleUserInURL = async (data) => {

  try {
    const response = await api.post('/api/users/createResponsibleUserInURL', data);
    console.log('Responsible user created successfully.');
    return response.data;
  } catch (error) {
    console.error("Error creating responsible user:", error);
    throw error;
  }
};
